import React from 'react';
import { FaGithub, FaLinkedinIn, FaEnvelope } from 'react-icons/fa';

const HeaderSocials = () => {
    return (
        <div className='home__socials'>
            <a href='https://github.com/jlemoureATSSU' className='home__social-link' target='_blank' rel='noreferrer'>
                <FaGithub />
            </a>

            <a href='https://www.linkedin.com/in/joseph-lemoure/' className='home__social-link' target='_blank' rel='noreferrer'>
                <FaLinkedinIn />
            </a>

            <a href='mailto:joelem316@gmail.com' className='home__social-link' target='_blank' rel='noreferrer'>
                <FaEnvelope />
            </a>
        </div>
    );
};

export default HeaderSocials;
